<template>
  <div class="page-container">
    <div>
      <el-button v-if="!noContent" type="primary" :disabled="addBtnLoading" @click="addOrUpdateHandle()">Add Nominee Director</el-button>
    </div>
    <div class="el-list protocols-wrapper">
      <el-row v-loading="dataListLoading" :gutter="30">
        <el-col v-if="noContent">
          <el-empty description=" ">
            <el-button type="primary" @click="addOrUpdateHandle()">Add Nominee Director</el-button>
          </el-empty>
        </el-col>
        <template v-if="!noContent">
          <el-col :span="6" v-for="item in dataList" :key="item.id">
            <el-card shadow="nerver" :body-style="{ padding: '0px' }" class="mt16 relative">
              <div class="module-item">
                <div class="module-desc">
                  <p class="item-wrap">
                    <span class="wd90 item-label">Name:</span>
                    <span class="item-content">{{ item.fullName }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd90 item-label">Country:</span>
                    <span class="item-content">{{ countryFormat(item.nationality) }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd90 item-label">Birth Date:</span>
                    <span class="item-content">{{ item.birthDate }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd90 item-label">ID Number:</span>
                    <span class="item-content">{{ item.identificationNo }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd90 item-label">Supplier:</span>
                    <span class="item-content">{{ item.supplier?.abbr || "" }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd90 item-label">Status:</span>
                    <span class="item-content" v-if="item.status == 0">Disable</span>
                    <span class="item-content" v-if="item.status == 1">Enable</span>
                  </p>
                  <p class="item-wrap">
                    <span class="wd90 item-label">Update:</span>
                    <span class="item-content">{{ item.updateTime }}</span>
                  </p>
                </div>
              </div>
              <ul class="el-card-actions">
                <li style="width: 33%" @click="deleteHandle(item.id)">
                  <svg-icon name="delete" class="fs16"></svg-icon>
                </li>
                <li style="width: 34%" @click="addOrUpdateHandle(item)">
                  <svg-icon name="edit" class="fs16"></svg-icon>
                </li>
                <li style="width: 33%" @click="viewHandle(item.id)">
                  <span class="el-icon-view fs16 fwb"></span>
                </li>
              </ul>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </div>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update ref="addOrUpdate" :supplierList="supplierList" @refreshDataList="getDataList"></add-or-update>
    <!-- 分页 -->
    <list-modal ref="listModal"></list-modal>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import ListModal from "./modal/List";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  components: {
    AddOrUpdate,
    ListModal,
  },
  data() {
    return {
      dataForm: {},
      dataList: [],
      supplierList: [],
      dataListLoading: false,
      addBtnLoading: false,
    };
  },
  computed: {
    noContent() {
      return this.dataList.length === 0;
    },
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http
        .get("/admin/stNomineeDirectorManage/getList")
        .then(res => {
          const resData = res.data || [];
          this.dataList = resData;
        })
        .catch(err => {})
        .finally(() => {
          this.dataListLoading = false;
        });
    },
    // 新增 / 修改
    addOrUpdateHandle(data) {
      this.$refs.addOrUpdate.init(data);
    },
    // 删除
    async deleteHandle(id) {
      await this.$confirm(`Delete this Nominee Director. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.$http
        .post(`/admin/stNomineeDirectorManage/${id}/delete`)
        .then(res => {
          this.$message({
            message: "success",
            type: "success",
            duration: 1500,
            onClose: () => this.getDataList(),
          });
        })
        .catch(err => {});
    },
    // 查看列表
    viewHandle(id) {
      this.$refs.listModal.init(id);
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      await this.getSupplierList();
    } catch (error) {
    } finally {
      this.addBtnLoading = false;
      this.getDataList();
    }
  },
};
</script>

<style lang="scss" scoped></style>
